import { render, staticRenderFns } from "./CampaignCouponForm.vue?vue&type=template&id=50342ab6&scoped=true"
import script from "./CampaignCouponForm.vue?vue&type=script&lang=js"
export * from "./CampaignCouponForm.vue?vue&type=script&lang=js"
import style0 from "./CampaignCouponForm.vue?vue&type=style&index=0&id=50342ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50342ab6",
  null
  
)

export default component.exports